/**
 * @fileoverview Agent definition for character-details-multimodal-generator-v3.
 *
 * This agent generates detailed character attributes using multimodal input.
 * It can process reference images, text instructions, or both, with a clear
 * priority hierarchy for attribute sources.
 *
 * @category entities.characters.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-details-multimodal-generator-v3',
  kind: 'primitive',
  name: 'Character Details Multimodal Generator',
  description: 'Generates detailed character attributes using images, text instructions, or both. Supports multimodal input with clear priority hierarchy.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'entities.characters.creation',
    usedBy: [
      'use-character-details-multimodal-generator-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-details-ideation-v2',
    ],
  },
};
